import LinesTotalWidget from './LinesTotalWidget';

export default LinesTotalWidget;
